import ClosingCostModal from "./ClosingCostModal";

export default ClosingCostModal;